import {FC, useRef} from 'react'
import './DropdownMenu.css'
import {useIntl} from 'react-intl'
import useOutsideClick from '../hook/OutsideClickHook'

export interface SettingOption {
  label: string
  icon?: string
  action: () => void
}

export interface SettingModalOption {
  label: string
  icon?: string
  targetModal: string
}

interface Props {
  visible: boolean
  settingOptions?: SettingOption[]
  shareOption?: SettingModalOption
  deleteOption?: SettingModalOption
  setOpenDropDown: (boolean) => void
}

const DropdownMenu: FC<Props> = ({
  visible,
  settingOptions,
  shareOption, 
  deleteOption,
  setOpenDropDown,
}: Props) => {
  const intl = useIntl()
  const wrapperRef = useRef<any>()
  useOutsideClick(wrapperRef, () => setOpenDropDown(false))

  return visible ? (
    <div ref={wrapperRef} style={{zIndex: '100'}}>
      <div className='flex flex-col dropDown menu menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold fs-6 w-275px mb-3 mt-3'>
        <div className='menu-item px-5'>
          <div className='menu-content d-flex align-items-center px-0'>
            <div className='d-flex flex-column'>
              <div className='fw-bolder d-flex align-items-center fs-6'>
                {intl.formatMessage({id: 'UTIL.SETTINGS'})}
              </div>
            </div>
          </div>
        </div>

        {settingOptions && settingOptions?.length > 0 && (
          <>
            <div className='separator my-2'></div>
            {settingOptions.map((option, index) => {
              return (
                <div
                  key={index}
                  className='d-flex flex-row flex-column-fluid bg-hover-light-primary py-3 px-5'
                  onClick={() => {
                    option.action()
                    setOpenDropDown((prev) => !prev)
                  }}
                >
                  <div className='d-flex flex-start menu-item menu-link align-items-center text-primary'>
                    {option.icon && <i className={`bi me-3 fs-5 text-primary ${option.icon}`}></i>}
                    <span className='indicator-label'>{option.label}</span>
                  </div>
                </div>
              )
            })}

            {shareOption && (
              <div
                className='d-flex flex-row flex-column-fluid bg-hover-light-primary py-3 px-5'
                data-bs-toggle='modal'
                data-bs-target={shareOption.targetModal}
              >
                <div className='d-flex flex-start menu-item menu-link align-items-center text-primary'>
                  {shareOption.icon && <i className={`bi me-3 fs-5 text-primary ${shareOption.icon}`}></i>}
                  <span className='indicator-label'>{shareOption.label}</span>
                </div>
              </div>
            )}
          </>
        )}

        {deleteOption && (
          <>
            <div className='separator my-2'></div>
            <div
              className='d-flex flex-row flex-column-fluid bg-hover-light-danger py-3 px-5'
              data-bs-toggle='modal'
              data-bs-target={deleteOption.targetModal}
            >
              <div className='d-flex flex-start menu-item menu-link align-items-center text-danger'>
                <i className='bi bi-trash me-3 fs-5 text-danger'></i>
                <span className='indicator-label'>{deleteOption.label}</span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  ) : (
    <></>
  )
}

export {DropdownMenu}
